export const getAllSeries = (state)=>{
    return state.listSeriesFilter
}

export const getAllSeriesComplete = (state)=>{
    return state.listSeries
}